import React from 'react';
import { Button } from 'new/elements/Button';
import { useFeatureFlag } from 'new/hooks/useFeatureFlags';

import s from './FlowInsightsHeader.module.scss';

type Props = {
  onClick?: () => void;
};

export const FlowInsightsHeader = ({ onClick }: Props) => {
  const isFlowInsightsV2Enabled = useFeatureFlag('UI_ENABLE_FLOW_INSIGHTS_V2');
  const enableExploreFlowLogs = isFlowInsightsV2Enabled && typeof onClick === 'function';

  return (
    <div className={s.container}>
      <p className={s.description}>
        <b>Flow Execution Insights</b> displays a historical record of Flow Runs, allowing you to
        monitor your data processing more effectively.
      </p>

      {enableExploreFlowLogs && (
        <Button onClick={onClick} variant="contained">
          Explore Flow Logs
        </Button>
      )}
    </div>
  );
};
